import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type TimeSpentColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const timeSpentColumnConfig = <T extends TableRow>({
  options,
}: TimeSpentColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'timeSpent',
  label: <Trans i18nKey="time_spent" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value}</div>
  ),
  acessorKey: 'timeSpent',
  sortable: false,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
